import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const STORAGE_KEY = 'cookieConsentDate';
const CONSENT_DURATION_MS = 2 * 30 * 24 * 60 * 60 * 1000; // 2 Monate

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) {
      setVisible(true);
      return;
    }
    const consentDate = new Date(stored).getTime();
    if (Date.now() - consentDate > CONSENT_DURATION_MS) {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(STORAGE_KEY, new Date().toISOString());
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-consent" role="dialog" aria-label="Cookie-Hinweis">
      <div className="cookie-consent__content">
        <p className="cookie-consent__text">
          Diese Website verwendet nur notwendige Cookies, um Inhalte der Website anzuzeigen und die Funktionalität zu gewährleisten.
          Weitere Informationen finden Sie in unserer{' '}
          <Link to="/datenschutz" className="cookie-consent__link">
            Datenschutzerklärung
          </Link>
          .
        </p>
        <button className="btn btn-primary cookie-consent__btn" onClick={handleAccept}>
          Akzeptieren
        </button>
      </div>
    </div>
  );
};

export default CookieConsent;
